var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5C5 4.22386 4.77267 3.99359 4.50506 4.06171C3.63988 4.28197 3 5.06626 3 6V10C3 11.1046 3.89543 12 5 12H10L12.5336 13.6891C12.733 13.822 13 13.6791 13 13.4394V6C13 5.06626 12.3601 4.28197 11.4949 4.06171C11.2273 3.99359 11 4.22386 11 4.5C11 4.77614 11.2373 4.98964 11.4795 5.12224C11.7897 5.29203 12 5.62145 12 6V12.1315L10.3028 11H5C4.44772 11 4 10.5523 4 10V6C4 5.62145 4.21034 5.29203 4.52051 5.12224C4.76274 4.98964 5 4.77614 5 4.5Z",
    fill: "#EE3E54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1,
    fill: "#EE3E54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06652 1.99779C7.03052 1.4578 7.45882 1 8 1C8.54118 1 8.96948 1.4578 8.93348 1.99779L8.71101 5.33481C8.68606 5.70913 8.37515 6 8 6C7.62485 6 7.31394 5.70913 7.28899 5.33481L7.06652 1.99779Z",
    fill: "#EE3E54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error_message.834ac7a62fb4a841e2e1f5753480f9ca.svg";
export { ForwardRef as ReactComponent };